import { RoutingState } from '@/contracts/store/RoutingContracts'

export const Routing =
{
    namespaced: true,
    state: (): RoutingState => (
    {
        showBackButton: false,
        backButtonRouteName: ''
    }),
    getters:
    {
        showBackButton(state: RoutingState): boolean
        {
            return state.showBackButton
        },
        backButtonRouteName(state: RoutingState): string
        {
            return state.backButtonRouteName
        }
    },
    mutations:
    {
        setBackButton(state: RoutingState, routeName: string): void
        {
            state.showBackButton = true
            state.backButtonRouteName = routeName
        },
        hideBackButton(state: RoutingState): void
        {
            state.showBackButton = false
        }
    }
}
